import './FullscreenDrawer.scss';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';
import { ReactNode } from 'react';

interface FullscreenDrawerProps {
  children: ReactNode;
  title: ReactNode;
  destroyOnHidden?: boolean;
  footer?: ReactNode;
  open: boolean;
  setOpen: Function;
  onClose?: Function;
  // Deshabilita la animación al abrirse otro drawer sobre este
  disablePush?: boolean;
  className?: string;
  placement?: 'left' | 'right' | 'top' | 'bottom';
}

const FullscreenDrawer = (props: FullscreenDrawerProps) => {
  const {
    children,
    title,
    destroyOnHidden,
    footer,
    open,
    setOpen,
    onClose,
    disablePush,
    className,
    placement = 'left',
  } = props;

  return (
    <Drawer
      push={!disablePush}
      className={`FullscreenDrawer  ${className ? className : ''}`}
      destroyOnHidden={destroyOnHidden}
      footer={footer}
      size="large"
      placement={placement}
      title={<div className="FullscreenDrawerHeaderTitle">{title}</div>}
      open={open}
      onClose={() => (onClose ? onClose() : setOpen(false))}
      classNames={{
        header: 'FullscreenDrawerHeader',
        body: 'FullscreenDrawerBody',
      }}
      closeIcon={<ArrowLeftOutlined className="FullscreenDrawerHeaderCloseButton" />}>
      {children}
    </Drawer>
  );
};

export default FullscreenDrawer;
